import { MapPin, ArrowLeft } from 'lucide-react';
import { DAY_OF_WEEK_LABELS, type DayOfWeek } from '@paulownia/shared/types';
import type { TenantMarketWithDetails } from './types';

interface MarketSelectionGateProps {
  tenantMarkets: TenantMarketWithDetails[];
  onSelectMarket: (marketId: string, city: string, dayOfWeek: number) => void;
  onBackClick?: () => void;
}

/**
 * Full-screen gate shown when no market is selected (currentMarket = null).
 * User must pick a market before accessing the merchant page.
 */
export function MarketSelectionGate({ tenantMarkets, onSelectMarket, onBackClick }: MarketSelectionGateProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="bg-orange-600 text-white p-6 pb-8 text-center relative">
        {onBackClick && (
          <button
            onClick={onBackClick}
            className="absolute left-3 top-1/2 -translate-y-1/2 p-2 hover:bg-white/20 rounded-lg transition-colors"
            title="Retour"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <MapPin className="w-10 h-10 mx-auto mb-2" />
        <h1 className="text-2xl font-bold">Choisissez votre marche</h1>
        <p className="text-orange-100 mt-1 text-sm">
          Les produits varient selon le lieu et le jour
        </p>
      </div>

      <div className="flex-1 max-w-lg mx-auto w-full px-4 py-6 space-y-3">
        {tenantMarkets.map((tm) => (
          <button
            key={tm.marketId}
            onClick={() => onSelectMarket(tm.marketId, tm.market.city, tm.market.dayOfWeek)}
            className="w-full bg-white rounded-xl shadow-md p-4 text-left hover:shadow-lg transition-shadow active:scale-[0.98]"
          >
            <div className="flex items-center gap-3">
              <div className="bg-orange-100 rounded-full p-2 flex-shrink-0">
                <MapPin className="w-5 h-5 text-orange-600" />
              </div>
              <div className="flex-1">
                <div className="font-semibold text-gray-900">{tm.market.city}</div>
                <div className="text-sm text-gray-500">
                  {DAY_OF_WEEK_LABELS[tm.market.dayOfWeek as DayOfWeek]} — {tm.market.openingTime} - {tm.market.closingTime}
                </div>
              </div>
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
